<template>
  <div class="app-container">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction" ref="userMasterTable">
      <wt-form-table-list ref="userMasterTableRef" slot="wtFormTableList" :form.sync="form" @on-button-action="onButtonAction">
        <template slot="isPublish" slot-scope="data">
          {{ data.row.isPublish === 1 ? '正常' : '禁用'}}
        </template>
        <template slot="wtFormTableListButtonsAfter" slot-scope="data">
          <wt-auth v-if="data.row.isPublish" :hasAnyPremission="form.formCode + ':USABLE'" class="search-form-btn">
            <el-button size="mini" type="primary" @click="toClickAction(data.row)">禁用</el-button>
          </wt-auth>
          <wt-auth v-if="!data.row.isPublish" :hasAnyPremission="form.formCode + ':USABLE'" class="search-form-btn">
            <el-button size="mini" type="primary" @click="toClickAction(data.row)">启用</el-button>
          </wt-auth>
        </template>
        <!-- <template slot="tableTopCustom">
          <div class="table-list-desc">当前站长数量 {{form.formResult.total}} 人</div>
        </template> -->
      </wt-form-table-list>
    </wt-form-table>
  </div>
</template>

<script>

export default {
  data() {
    return {
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULE_USER_MASTER_SIGN',
        formComponent: {
          list: { type: 'default',
            value: '/modules/userEmployees/userEmployeesSignList',
            params: {
              updateTimeRange: [] }}
        },
        formInputsData: [
          { name: '站点',
            key: 'siteId',
            value: '',
            type: 'cascader',
            options: [],
            relateField: ['level'],
            filterable: true,
            props: { children: 'childList', label: 'name', value: 'id', expandTrigger: 'hover', emitPath: false, multiple: false }},
          { name: '姓名', key: 'userName', value: '', type: 'text' },
          { name: '时间', key: 'createTimeRange', value: [], type: 'datetime' }
        ],
        formButtonsData: [
          { name: '导出Excel', key: 'EXCEL', action: 'EXCEL', hidden: false, url: window.wtConst.BASE_API + '/modules/userEmployees/userEmployeesSignListExport', fileName: '考勤管理', permission: 'EXPORT' }],
        formTableData: [
          { name: '站点', key: 'siteName', type: 'text' },
          { name: '姓名', key: 'userName', type: 'text' },
          { name: '地址', key: 'address', type: 'text' },
          { name: '签到时间', key: 'createTime', type: 'text' }],
        formTableButtonsData: null,
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, index: true, buttonMinWidth: 320, buttonWidth: 320, buttonHidden: true }
      }
    }
  },
  mounted() {
    this.orgTreeList()
  },
  methods: {
    /*  ------------------------- 按钮相关  -------------------------  */
    onButtonAction(data) {
      console.log('data', data)
    },
    // 站点
    orgTreeList() {
      this.$api.siteManage.org.orgTreeList().then(res => {
        this.$wtUtil.setSiteLevelKey(res.data)
        this.form.formInputsData[0].options = res.data
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.table-list-desc {
  padding: 20px;
  color: #333333;
  font-size: 14px;
}
</style>
